import React from 'react';
import { Checkbox } from '../../assets/svg/Checkbox';

export interface BasicCheckboxProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
}

export const BasicCheckbox: React.FC<BasicCheckboxProps> = ({ checked, onChange }) => (
  <div
    role="checkbox"
    aria-checked={checked}
    onClick={() => onChange(!checked)}
    style={{ cursor: 'pointer', display: 'inline-flex', alignItems: 'center' }}
  >
    <Checkbox checked={checked} />
  </div>
); 